import type { ColDef, ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'
import type { Menu } from '~/components/ActionMenu'
import type { IReplyReviewMacro } from '~/types/review'

import ActionMenu from '~/components/ActionMenu'
import ApplicationsListCellRenderer from '~/components/CellRenderers/ApplicationsListCellRenderer'
import LongTextCellRenderer from '~/components/CellRenderers/LongTextCellRenderer'
import TextCellRenderer from '~/components/CellRenderers/TextCellRenderer'
import { actionsColDef, applicationsListColDef, longTextColDef, textColDef } from '~/utils/table'

export interface IContext {
  handleDelete: (isOpen: boolean, macro?: IReplyReviewMacro) => () => void
  handleEdit: (isOpen: boolean, macro?: IReplyReviewMacro) => () => void
  reviewsWriteAuthorized: boolean
}

const ActionsCellRenderer = ({
  context,
  data,
}: ICellRendererParams<IReplyReviewMacro, unknown, IContext>): ReactElement => {
  if (data) {
    const { handleDelete, handleEdit, reviewsWriteAuthorized } = context

    const menu: Menu = {
      actions: [
        {
          action: handleEdit(true, data),
          label: 'Edit',
          type: 'default',
        },
        {
          action: handleDelete(true, data),
          label: 'Delete',
          type: 'default',
        },
      ],
    }

    return <ActionMenu disabled={!reviewsWriteAuthorized} menu={menu} placement="top" />
  }

  return <div />
}

const columns: ColDef[] = [
  applicationsListColDef(ApplicationsListCellRenderer, {
    field: 'applications',
  }),
  longTextColDef(LongTextCellRenderer, {
    field: 'content',
    headerName: 'Macro',
  }),
  textColDef(TextCellRenderer, {
    field: 'name',
    headerName: 'Name',
    tooltipField: undefined,
  }),
  actionsColDef(ActionsCellRenderer, {
    field: 'actions',
  }),
]

export default columns
